import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

/** A rounded picture panel with a dark wash, the title and one button. */
export const schema: ComponentSchema = {
  type: 'offer-banner',
  label: 'Offer banner',
  description: 'A picture panel with a title, text and one button.',
  supportedPages: ['home', 'shop', 'category'],
  variants: [{ id: 'v1', label: 'Picture panel' }],
  commonFields: [
    { key: 'image', label: 'Picture', type: 'image' },
    { key: 'title', label: 'Title', type: 'string', default: 'Special offer' },
    { key: 'subtitle', label: 'Text', type: 'text' },
    { key: 'ctaText', label: 'Button text', type: 'string', default: 'Shop now' },
    { key: 'ctaLink', label: 'Button link', type: 'string', default: '/shop' },
    { key: 'overlayOpacity', label: 'Dark wash (30–90)', type: 'number', default: 50 },
    ...SECTION_STYLE_FIELDS,
  ],
}
